export const GLOBAL_TIMEOUT = 8000; //[ms]

export const LIGHT_PAPER_URL = "https://fugazi-ai.gitbook.io/light-paper";

export const DEFAULT_CONTRACT_ADDRESS = "0xd7ee10047a75fa603591bce0524b8a52fef7b672";

export const OPEN_SEA_URL = "";

export const LOGO_PACK_SRC = "/download/LogoPack.zip";
